import { useQuery } from '@tanstack/react-query';

import { loadCalendarEvent } from './requests';

export const useCalendarEvent = (shortId: string) => {
  return useQuery({
    queryKey: ['calendar-event', shortId],
    queryFn: () => loadCalendarEvent(shortId),
  });
};
